import React from "react";
import "./gallery.css";
import { motion } from "framer-motion";
import { fadeVariants } from "../../Animations/fadeVariants.js";

const images = [
  "https://i.imgur.com/G7VT7Ac.jpeg",
  "https://i.imgur.com/bp7WQAI.jpeg",
  "https://i.imgur.com/QSyf82G.jpeg",
  "https://i.imgur.com/VeWpKUs.jpeg",
  "https://i.imgur.com/MVZm6yM.jpeg",
  "https://i.imgur.com/GBxC9hn.jpeg",
  "https://i.imgur.com/JsKkytT.jpeg",
  "https://i.imgur.com/ILKUe01.jpeg",
  "https://i.imgur.com/XId8MQY.jpeg",
  "https://i.imgur.com/pbF7SeL.jpeg",
  "https://i.imgur.com/eo8u8EG.jpeg",
  "https://i.imgur.com/sJ1y8t8.jpeg",
  "https://i.imgur.com/NzigoSM.jpeg",
  "https://i.imgur.com/neQXS1Z.jpeg",
  "https://i.imgur.com/YOzWnuU.jpeg",
  "https://i.imgur.com/rugSpdJ.jpeg",
  "https://i.imgur.com/YPaA9pp.jpeg",
  "https://i.imgur.com/f9o9nkk.jpeg",
  "https://i.imgur.com/qknPg4r.jpeg",
  "https://i.imgur.com/T2eXh6Z.jpeg",
  "https://i.imgur.com/9LKKFcG.jpeg",
  "https://i.imgur.com/qeaCoFg.jpeg",
  "https://i.imgur.com/zJwTSI4.jpeg",
  "https://i.imgur.com/UFtfJ9O.jpeg",
  "https://i.imgur.com/DiABfL9.jpeg",
  "https://i.imgur.com/TSM87rO.jpeg",
  "https://i.imgur.com/PAWJU3c.jpeg",
  "https://i.imgur.com/XJvhCcU.jpeg",
  "https://i.imgur.com/I60qnP3.jpeg",
];

function Gallery() {
  return (
    <motion.div
      className="gallery-wrapper"
      variants={fadeVariants}
      initial="initial"
      animate="animate"
      exit="exit"
    >
      <div className="header-1">
        <a href="/" className="home-button">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24px"
            viewBox="0 -960 960 960"
            width="24px"
            fill="#1f1f1f"
          >
            <path d="M400-80 0-480l400-400 71 71-329 329 329 329-71 71Z" />
          </svg>
        </a>
        <h1 className="header">Gallery</h1>
      </div>{" "}
      <div className="masonry-gallery">
        {images.map((src, index) => (
          <motion.img
            key={index}
            src={src}
            alt={`Dog ${index}`}
            className="gallery-img"
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: index * 0.1, duration: 0.6, ease: "easeOut" }}
          />
        ))}
      </div>
    </motion.div>
  );
}

export default Gallery;
